/**
 * Lesson word/phrase tutorial coachmark — web counterpart of the native
 * SpotlightTutorial phases iOS drives from VideoNew.tsx:143-194 (word_click →
 * phrase_highlight, gated on userSettings.wordClickTutorialComplete /
 * phraseHighlightTutorialComplete). Thin wrapper over the shared
 * TranscriptCoachmark, which points the finger at the real first word / first
 * line, dims the rest, and highlights the target. Non-blocking: the user
 * completes a phase by actually tapping a word / highlighting a phrase below.
 */
import TranscriptCoachmark from "@/features/tutorial/components/TranscriptCoachmark";
import { type TranscriptCoachmarkPhase } from "@/features/tutorial/components/transcriptCoachmarkPhases";

export type LessonTutorialPhase = TranscriptCoachmarkPhase;

function LessonTutorialOverlay({
  phase,
}: {
  phase: LessonTutorialPhase;
  /**
   * Accepted for caller-compat (iOS VideoNew `phraseHighlightTutorialTargetPhrase`)
   * but intentionally NOT shown: the web coachmark always spotlights the first
   * transcript line, so naming a different authored phrase in the copy would
   * mismatch what the finger/spotlight point at.
   */
  targetPhrase?: string;
}) {
  return <TranscriptCoachmark phase={phase} />;
}

export default LessonTutorialOverlay;
